module.exports = __webpack_public_path__ + "media/images/logo_mastercard-faeb25ba3bcdfa7b1c370ffd928c622e.png";